/** @jsxImportSource @emotion/react */

import Typography from '@mui/material/Typography'
import { FC, useState } from 'react'
import TabsNavigation from 'components/TabsNavigation'
import { TabsItem } from 'types/tabsItem'
import FAQ from 'pagesNew/FAQ'
import { FaqPages } from '__generatedTypes__/globalTypes'
import { DescriptionForm, DescriptionPages } from 'components/DescriptionForm'
import { PerformanceTabs } from './consts'
import * as classes from './styles'

const tabs = Object.values(PerformanceTabs).map((item) => ({ id: item, title: item }))

export const Performance: FC = () => {
  const [activeTab, setActiveTab] = useState<TabsItem>(tabs[0])

  const renderTab = () => {
    const { title } = activeTab

    if (title === PerformanceTabs.FAQ) {
      return <FAQ page={FaqPages.Performance} />
    }

    if (title === PerformanceTabs.DESCRIPTION) {
      return <DescriptionForm page={DescriptionPages.Performance} />
    }
  }

  return (
    <div css={classes.container}>
      <Typography variant="title3" css={classes.title}>
        Performance
      </Typography>

      <TabsNavigation<TabsItem> tabs={tabs} value={activeTab} onChange={setActiveTab} css={classes.tabs} />

      {renderTab()}
    </div>
  )
}
